import { useState, useEffect } from 'react';

import { useAppSelector, useDocumentTitle } from '../common/hooks';
import { t } from '../common/i18n';

import { Header, Content, ButtonLink } from '../common/components';

import { getFeeds } from './services/FeedService';
import { CardFeed } from '../common/components/Cards/CardFeed';
import { IGetResFeed, IGetResReadReceiptSummary } from '../frontend-libs/evlapp-types';
import { selectSecurity } from '../common/store/securitySlice';
import { getReadReceiptSummary } from '../common/services/ReadReceiptService';
import routes from '../common/constants/routes';

export const FeedDefault: React.FC = () => {
  const namespace = 'Feed.Default';
  useDocumentTitle(t('Feed.title'));

  const security = useAppSelector(selectSecurity).ui;
  const isAdmin = security.isAdmin;

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [feed, setFeed] = useState<IGetResFeed>([]);
  const [receiptSummary, setReceiptSummary] = useState<IGetResReadReceiptSummary | null>(null);

  useEffect(() => {
    async function fetchFeed() {
      const data = await getFeeds();
      setFeed(data);
      setIsLoading(false);
    }
    fetchFeed();
    if (isAdmin) {
      getReadReceiptSummary('message')
        .then((res) => setReceiptSummary(res))
        .catch(() => undefined);
    }
  }, [isAdmin]);

  return (
    <>
      <Header
        title={t('Header.title', namespace)}
        customBacklink={routes.poll}
        actions={isAdmin && <ButtonLink title={t('Header.add', namespace)} to="add" size="small" />}
      />

      <Content isLoading={isLoading} isEmpty={feed.length === 0} isEmptyText={t('Content.emptyText', namespace)}>
        <div className="List">
          {feed.map((item) => (
            <CardFeed
              key={item.id}
              {...item}
              detail={item.id}
              readReceipt={
                isAdmin && item.isPublished && receiptSummary !== null
                  ? {
                      readCount:
                        receiptSummary.subjects.find((subject) => subject.subjectId === item.id)?.readCount ?? 0,
                      totalCount: receiptSummary.totalMembers,
                    }
                  : undefined
              }
            />
          ))}
        </div>
      </Content>
    </>
  );
};
